export const TestIds = {
    overview: {
        containers: {
            main: 'OVERVIEW.PAGE.CONTAINER.MAIN',
            mail: 'OVERVIEW.PAGE.CONTAINER.MAIL',
            infoSection: 'OVERVIEW.INFO.CONTAINER.SECTION',
            cardUK: 'OVERVIEW.UNITED_KINGDOM.CONTAINER.CARD',
            cardUS: 'OVERVIEW.UNITED_STATES.CONTAINER.CARD',
            cardDescriptionUK: 'OVERVIEW.UNITED_KINGDOM.CONTAINER.CARD.DESCRIPTION',
            cardDescriptionUS: 'OVERVIEW.UNITED_STATES.CONTAINER.CARD.DESCRIPTION',
        },
        actions: {
            buttonExploreUK: 'OVERVIEW.UNITED_KINGDOM.BUTTON.EXPLORE',
            buttonExploreUS: 'OVERVIEW.UNITED_STATES.BUTTON.EXPLORE',
        },
    },
    projection: {
        header: {
            title: 'PAGE.SECTION.TITLE.TEXT',
        },
        containers: {
            videoGuide: 'PROJECTION.ONBOARDING.MODAL.MAIN',
            videoGuideTitle: 'PROJECTION.ONBOARDING.MODAL.TITLE',
            tabContainer: 'PROJECTION.TABS.CONTAINER.MAIN',
        },
        plotlyContainer: {
            main: 'PLOTLY.CONTAINER.MAIN',
            title: 'PLOTLY.CONTAINER.MAIN.TITLE',
            plot: 'PLOTLY.CONTAINER.PLOT',
            graph: 'PLOTLY.CONTAINER.GRAPH',
            segmentSection: 'PROJECTION.PLOTLY.SECTION.SEGMENT',
            //LEGENDS
            legends: 'PROJECTION.PLOTLY.LEGENDS',
            legendstitle: 'PROJECTION.PLOTLY.LEGENDS.TITLE',
            //legendTitle: example PLOTLY.CONTAINER.LEGEND.ITEM-0, use indexes
            //legendColorbox: example PLOTLY.CONTAINER.LEGEND.ITEM-0.COLORBOX, use indexes

            //DROPDOWNS
            groupBySection: 'PROJECTION.PLOTLY.SECTION.GROUPBY',
            groupBySectionDropdown: 'PROJECTION.PLOTLY.SECTION.GROUPBY.DROPDOWN',
            groupBySectionDropdownTotalPopulation:
                'PROJECTION.PLOTLY.SECTION.GROUPBY.DROPDOWN.TOTALPOPULATION',
            groupBySectionDropdownSubcategories:
                'PROJECTION.PLOTLY.SECTION.GROUPBY.DROPDOWN.SUBCATEGORIES',
            groupBySectionDropdownEthnicGroup:
                'PROJECTION.PLOTLY.SECTION.GROUPBY.DROPDOWN.ETHNICGROUP',
            groupBySectionDropdownDriver: 'PROJECTION.PLOTLY.SECTION.SHOWBY.DROPDOWN.DRIVER',
            groupBySectionDropdownMulticultural:
                'PROJECTION.PLOTLY.SECTION.GROUPBY.DROPDOWN.COMBINEDMULTICULTURAL',
            groupBySectionDropdownNoAggregation:
                'PROJECTION.PLOTLY.SECTION.GROUPBY.DROPDOWN.NOAGGREGATION',
            groupBySectionDropdownGeography: 'PROJECTION.PLOTLY.SECTION.GROUPBY.DROPDOWN.GEOGRAPHY',
            groupBySectionDropdownSex: 'PROJECTION.PLOTLY.SECTION.GROUPBY.DROPDOWN.SEX',
            groupBySectionDropdownAge: 'PROJECTION.PLOTLY.SECTION.GROUPBY.DROPDOWN.AGE',
            groupBySectionDropdownSocioEconomic:
                'PROJECTION.PLOTLY.SECTION.GROUPBY.DROPDOWN.SOCIOECONOMICSCENARIO',
            groupBySectionDropdownIncome:
                'PROJECTION.PLOTLY.SECTION.GROUPBY.DROPDOWN.DISPOSABLEINCOME',

            showBySection: 'PROJECTION.PLOTLY.SECTION.SHOWBY',
            showBySectionDropdown: 'PROJECTION.PLOTLY.SECTION.SHOWBY.DROPDOWN',
            showBySectionDropdownGeography: 'PROJECTION.PLOTLY.SECTION.SHOWBY.DROPDOWN.GEOGRAPHY',
            showBySectionDropdownSex: 'PROJECTION.PLOTLY.SECTION.SHOWBY.DROPDOWN.SEX',
            showBySectionDropdownAge: 'PROJECTION.PLOTLY.SECTION.SHOWBY.DROPDOWN.AGE',
            showBySectionDropdownEthnicGroup:
                'PROJECTION.PLOTLY.SECTION.SHOWBY.DROPDOWN.ETHNICGROUP',
            showBySectionDropdownSubcategories:
                'PROJECTION.PLOTLY.SECTION.SHOWBY.DROPDOWN.SUBCATEGORIES',
            showBySectionDropdownIncome:
                'PROJECTION.PLOTLY.SECTION.SHOWBY.DROPDOWN.DISPOSABLEINCOME',
            showBySectionDropdownNoAggregation:
                'PROJECTION.PLOTLY.SECTION.SHOWBY.DROPDOWN.NOAGGREGATION',
            showBySectionDropdownSocioEconomic:
                'PROJECTION.PLOTLY.SECTION.SHOWBY.DROPDOWN.SOCIOECONOMICSCENARIO',
            xaxisSection: 'PROJECTION.PLOTLY.SECTION.XAXIS',
            yearsSection: 'PROJECTION.PLOTLY.SECTION.YEARS',
        },
        tabs: {
            population: 'PROJECTION.MAIN.TAB.POPULATION',
            demographic: 'PROJECTION.MAIN.TAB.DEMOGRAPHIC',
            income: 'PROJECTION.MAIN.TAB.DISPOSABLEINCOME',
            categorySpend: 'PROJECTION.MAIN.TAB.CATEGORYSPEND',
            driversOfGrowth: 'PROJECTION.MAIN.TAB.DRIVERSOFGROWTH',
        },
        actions: {
            backButton: 'PAGE.ACTIONS.BUTTON.BACK',
            createScenario: 'PAGE.ACTIONS.BUTTON.CREATE_SCENARIO',
            videoGuideButton: 'PROJECTION.ONBOARDING.BUTTON.MAIN',
            learnMoreButton: 'PROJECTION.LEARNMORE.BUTTON.TEXT',
            downloadButton: 'PROJECTION.DOWNLOAD.BUTTON.ICON',
        },
        sidePanel: {
            mainContainer: 'PROJECTION.SIDEPANEL.CONTAINER.MAIN',
            title: 'PROJECTION.SIDEPANEL.TITLE.TEXT',
            resetButton: 'PROJECTION.SIDEPANEL.BUTTON.RESET',
            runButton: 'PROJECTION.SIDEPANEL.BUTTON.RUN',
            //DROPDOWNS
            regionSection: 'PROJECTION.SIDEPANEL.SECTION.MAP',
            regionSectionTitle: 'PROJECTION.SIDEPANEL.SECTION.MAP.TITLE',
            regionSectionDropdown: 'PROJECTION.SIDEPANEL.SECTION.MAP.DROPDOWN',
            regionSectionPopupTitle: 'PROJECTION.SIDEPANEL.SECTION.MAP.POPUP.TITLE',
            regionSectionPopupClose: 'PROJECTION.SIDEPANEL.SECTION.MAP.POPUP.CLOSE',
            regionSectionPopupSegment: 'PROJECTION.SIDEPANEL.SECTION.MAP.POPUP.SEGMENT',
            regionSectionPopupSegmentRegions:
                'PROJECTION.SIDEPANEL.SECTION.MAP.POPUP.SEGMENT.REGION',
            regionSectionPopupSegmentDMA: 'PROJECTION.SIDEPANEL.SECTION.MAP.POPUP.SEGMENT.DMA',
            regionSectionPopupRegionGraph: 'PROJECTION.SIDEPANEL.SECTION.MAP.REGION.GRAPH',
            regionSectionPopupDMAGraph: 'PROJECTION.SIDEPANEL.SECTION.MAP.DMA.GRAPH',
            regionSectionPopupSubdropdown: 'PROJECTION.SIDEPANEL.SECTION.MAP.SUBDROPDOWN',
            regionSectionPopupSubdropdownWest: 'PROJECTION.SIDEPANEL.SECTION.MAP.SUBDROPDOWN.WEST',
            regionSectionPopupSubdropdownMidwest:
                'PROJECTION.SIDEPANEL.SECTION.MAP.SUBDROPDOWN.MIDWEST',
            regionSectionPopupSubdropdownSouth:
                'PROJECTION.SIDEPANEL.SECTION.MAP.SUBDROPDOWN.SOUTH',
            regionSectionPopupSubdropdownNorthEast:
                'PROJECTION.SIDEPANEL.SECTION.MAP.SUBDROPDOWN.NORTHEAST',
            categorySection: 'PROJECTION.SIDEPANEL.SECTION.CATEGORY',
            categorySectionDropdown: 'PROJECTION.SIDEPANEL.SECTION.CATEGORY.DROPDOWN',
            categorySectionDropdownAlcoholicBeverages:
                'PROJECTION.SIDEPANEL.SECTION.CATEGORY.DROPDOWN.ALCOHOLICBEVERAGES',
            categorySectionDropdownConsumerElectronics:
                'PROJECTION.SIDEPANEL.SECTION.CATEGORY.DROPDOWN.CONSUMERELECTRONICS',
            categorySectionDropdownGrocery:
                'PROJECTION.SIDEPANEL.SECTION.CATEGORY.DROPDOWN.GROCERY',
            categorySectionDropdownInsurance:
                'PROJECTION.SIDEPANEL.SECTION.CATEGORY.DROPDOWN.INSURANCE',
            categorySectionDropdownNonAlcoholic:
                'PROJECTION.SIDEPANEL.SECTION.CATEGORY.DROPDOWN.NONALCOHOLICBEVERAGES',
            categorySectionDropdownSportRecreation:
                'PROJECTION.SIDEPANEL.SECTION.CATEGORY.DROPDOWN.SPORTS&RECREATION',
            categorySectionDropdownSubscriptions:
                'PROJECTION.SIDEPANEL.SECTION.CATEGORY.DROPDOWN.SUBSCRIPTIONS',
            categorySectionDropdownBeautyPersonalCare:
                'PROJECTION.SIDEPANEL.SECTION.CATEGORY.DROPDOWN.BEAUTYPERSONALCARE',
            categorySectionDropdownClothingFashion:
                'PROJECTION.SIDEPANEL.SECTION.CATEGORY.DROPDOWN.CLOTHINGFASHION',
            categorySectionDropdownEatingDrinking:
                'PROJECTION.SIDEPANEL.SECTION.CATEGORY.DROPDOWN.EATINGDRINKINGOUT',
            categorySectionDropdownFinancialProducts:
                'PROJECTION.SIDEPANEL.SECTION.CATEGORY.DROPDOWN.FINANCIALPRODUCTSSERVICES',
            categorySectionDropdownGroceries:
                'PROJECTION.SIDEPANEL.SECTION.CATEGORY.DROPDOWN.GROCERIES',
            subcategorySection: 'PROJECTION.SIDEPANEL.SECTION.SUBCATEGORY',
            subcategorySectionDropdown: 'PROJECTION.SIDEPANEL.SECTION.SUBCATEGORY.DROPDOWN',
            subcategorySectionDropdownBakedGoods:
                'PROJECTION.SIDEPANEL.SECTION.SUBCATEGORY.DROPDOWN.BAKEDGOODS',
            subcategorySectionDropdownGeneralFood:
                'PROJECTION.SIDEPANEL.SECTION.SUBCATEGORY.DROPDOWN.GENERALFOOD',
            subcategorySectionDropdownCleaning:
                'PROJECTION.SIDEPANEL.SECTION.SUBCATEGORY.DROPDOWN.CLEANINGHYGIENE',
            subcategorySectionDropdownPetFood:
                'PROJECTION.SIDEPANEL.SECTION.SUBCATEGORY.DROPDOWN.PETFOOD',
            subcategorySectionDropdownSweetSnacks:
                'PROJECTION.SIDEPANEL.SECTION.SUBCATEGORY.DROPDOWN.SWEETSCANDYSNACKS',
            subcategorySectionDropdownAlcoholAtHome:
                'PROJECTION.SIDEPANEL.SECTION.SUBCATEGORY.DROPDOWN.ALCOHOLATHOME',
            subcategorySectionDropdownBabycare:
                'PROJECTION.SIDEPANEL.SECTION.SUBCATEGORY.DROPDOWN.BABYCARE',
            subcategorySectionDropdownCleaningProducts:
                'PROJECTION.SIDEPANEL.SECTION.SUBCATEGORY.DROPDOWN.CLEANINGPRODUCTS',
            subcategorySectionDropdownFood:
                'PROJECTION.SIDEPANEL.SECTION.SUBCATEGORY.DROPDOWN.FOOD',
            subcategorySectionDropdownNewspapers:
                'PROJECTION.SIDEPANEL.SECTION.SUBCATEGORY.DROPDOWN.NEWSPAPERSMAGAZINES',
            subcategorySectionDropdownPetcare:
                'PROJECTION.SIDEPANEL.SECTION.SUBCATEGORY.DROPDOWN.PETCARE',
            ethnicSection: 'PROJECTION.SIDEPANEL.SECTION.ETHNIC',
            ethnicSectionDropdown: 'PROJECTION.SIDEPANEL.SECTION.ETHNIC.DROPDOWN',
            ethnicSectionDropdownAsian: 'PROJECTION.SIDEPANEL.SECTION.ETHNIC.DROPDOWN.ASIAN',
            ethnicSectionDropdownBlack: 'PROJECTION.SIDEPANEL.SECTION.ETHNIC.DROPDOWN.BLACK',
            ethnicSectionDropdownHispanicAnyRace:
                'PROJECTION.SIDEPANEL.SECTION.ETHNIC.DROPDOWN.HISPANICANYRACE',
            ethnicSectionDropdownMixedAdditionalRace:
                'PROJECTION.SIDEPANEL.SECTION.ETHNIC.DROPDOWN.MIXEDRACEADDITIONALRACES',
            ethnicSectionDropdownWhite: 'PROJECTION.SIDEPANEL.SECTION.ETHNIC.DROPDOWN.WHITE',
            ethnicSectionDropdownEastSoutheastAsian:
                'PROJECTION.SIDEPANEL.SECTION.ETHNIC.DROPDOWN.EASTSOUTHEASTASIAN',
            ethnicSectionDropdownSouthAsianPakistani:
                'PROJECTION.SIDEPANEL.SECTION.ETHNIC.DROPDOWN.SOUTHASIANPAKISTANI',
            ethnicSectionDropdownSouthAsianBangladeshi:
                'PROJECTION.SIDEPANEL.SECTION.ETHNIC.DROPDOWN.SOUTHASIANBANGLADESHI',
            ethnicSectionDropdownMiddleEastern:
                'PROJECTION.SIDEPANEL.SECTION.ETHNIC.DROPDOWN.MIDDLEEASTERN',
            ethnicSectionDropdownMixed: 'PROJECTION.SIDEPANEL.SECTION.ETHNIC.DROPDOWN.MIXED',
            ethnicSectionDropdownSouthAsianIndian:
                'PROJECTION.SIDEPANEL.SECTION.ETHNIC.DROPDOWN.SOUTHASIANINDIAN',
            ageSection: 'PROJECTION.SIDEPANEL.SECTION.AGE',
            ageSectionDropdown: 'PROJECTION.SIDEPANEL.SECTION.AGE.DROPDOWN',
            ageSectionDropdown18_24: 'PROJECTION.SIDEPANEL.SECTION.AGE.DROPDOWN.1824',
            ageSectionDropdown16_24: 'PROJECTION.SIDEPANEL.SECTION.AGE.DROPDOWN.1624',
            ageSectionDropdown25_29: 'PROJECTION.SIDEPANEL.SECTION.AGE.DROPDOWN.2529',
            ageSectionDropdown30_39: 'PROJECTION.SIDEPANEL.SECTION.AGE.DROPDOWN.3039',
            ageSectionDropdown40_49: 'PROJECTION.SIDEPANEL.SECTION.AGE.DROPDOWN.4049',
            ageSectionDropdown25_34: 'PROJECTION.SIDEPANEL.SECTION.AGE.DROPDOWN.2534',
            ageSectionDropdown35_49: 'PROJECTION.SIDEPANEL.SECTION.AGE.DROPDOWN.3549',
            ageSectionDropdown50_64: 'PROJECTION.SIDEPANEL.SECTION.AGE.DROPDOWN.5064',
            ageSectionDropdown65plus: 'PROJECTION.SIDEPANEL.SECTION.AGE.DROPDOWN.65',
            ageSectionDropdownLess16: 'PROJECTION.SIDEPANEL.SECTION.AGE.DROPDOWN.16',
            sexSection: 'PROJECTION.SIDEPANEL.SECTION.SEX',
            sexSectionDropdown: 'PROJECTION.SIDEPANEL.SECTION.SEX.DROPDOWN',
            sexSectionDropdownMale: 'PROJECTION.SIDEPANEL.SECTION.SEX.DROPDOWN.MALE',
            sexSectionDropdownFemale: 'PROJECTION.SIDEPANEL.SECTION.SEX.DROPDOWN.FEMALE',
            incomeSection: 'PROJECTION.SIDEPANEL.SECTION.INCOME',
            incomeSectionDropdown: 'PROJECTION.SIDEPANEL.SECTION.INCOME.DROPDOWN',
            incomeSectionDropdownLess10000: 'PROJECTION.SIDEPANEL.SECTION.INCOME.DROPDOWN.10000',
            incomeSectionDropdownLess10000_25000:
                'PROJECTION.SIDEPANEL.SECTION.INCOME.DROPDOWN.1000025000',
            incomeSectionDropdownLess25000_50000:
                'PROJECTION.SIDEPANEL.SECTION.INCOME.DROPDOWN.2500050000',
            incomeSectionDropdownLess50000_75000:
                'PROJECTION.SIDEPANEL.SECTION.INCOME.DROPDOWN.5000075000',
            incomeSectionDropdownLess75000_100000:
                'PROJECTION.SIDEPANEL.SECTION.INCOME.DROPDOWN.75000100000',
            incomeSectionDropdownMore100000: 'PROJECTION.SIDEPANEL.SECTION.INCOME.DROPDOWN.100000',
            incomeSectionDropdownLowIncome:
                'PROJECTION.SIDEPANEL.SECTION.INCOME.DROPDOWN.LOWINCOME',
            incomeSectionDropdownMiddleIncome:
                'PROJECTION.SIDEPANEL.SECTION.INCOME.DROPDOWN.MIDLEVELINCOME',
            incomeSectionDropdownHighIncome:
                'PROJECTION.SIDEPANEL.SECTION.INCOME.DROPDOWN.HIGHINCOME',
        },
    },
    scenario: {
        actions: {
            howToUseButton: 'SCENARIO.PAGE.BUTTON.HOWTOUSE',
            downloadButton: 'SCENARIO.PLOT.DOWNLOAD.BUTTON',
        },
        selection: 'SCENARIO.SELECTION',
        sexSection: 'SCENARIO.SELECTION.SEX',
        sexSectionTitle: 'SCENARIO.SELECTION.SEX.TITLE',
        sexSectionSegment: 'SCENARIO.SELECTION.SEX.SEGMENT',
        sexSectionSegmentAll: 'SCENARIO.SELECTION.SEX.SEGMENT.ALL',
        sexSectionSegmentFemale: 'SCENARIO.SELECTION.SEX.SEGMENT.FEMALE',
        sexSectionSegmentMale: 'SCENARIO.SELECTION.SEX.SEGMENT.MALE',
        ageSection: 'SCENARIO.SELECTION.AGE',
        ageSectionTitle: 'SCENARIO.SELECTION.AGE.TITLE',
        ageSectionDropdown: 'SCENARIO.SELECTION.AGE.SECTION.DROPDOWN',
        ageSectionDropdown18_24: 'SCENARIO.SELECTION.AGE.SECTION.DROPDOWN.1824',
        ageSectionDropdown25_34: 'SCENARIO.SELECTION.AGE.SECTION.DROPDOWN.2534',
        ageSectionDropdown35_49: 'SCENARIO.SELECTION.AGE.SECTION.DROPDOWN.3549',
        ageSectionDropdown50_64: 'SCENARIO.SELECTION.AGE.SECTION.DROPDOWN.5064',
        ageSectionDropdownMore65: 'SCENARIO.SELECTION.AGE.SECTION.DROPDOWN.65',
        ethnicSection: 'SCENARIO.SELECTION.ETHNIC',
        ethnicSectionTitle: 'SCENARIO.SELECTION.ETHNIC.TITLE',
        ethnicSectionDropdown: 'SCENARIO.SELECTION.ETHNIC.SECTION.DROPDOWN',
        ethnicSectionDropdownWhite: 'SCENARIO.SELECTION.ETHNIC.SECTION.DROPDOWN.WHITE',
        ethnicSectionDropdownBlack: 'SCENARIO.SELECTION.ETHNIC.SECTION.DROPDOWN.BLACK',
        ethnicSectionDropdownAsian: 'SCENARIO.SELECTION.ETHNIC.SECTION.DROPDOWN.ASIAN',
        ethnicSectionDropdownHispanicAnyRace:
            'SCENARIO.SELECTION.ETHNIC.SECTION.DROPDOWN.HISPANICANYRACE',
        ethnicSectionDropdownMixed: 'SCENARIO.SELECTION.ETHNIC.SECTION.DROPDOWN.MIXEDOTHERRACES',
        categorySection: 'SCENARIO.SELECTION.CATEGORY',
        categorySectionTitle: 'SCENARIO.SELECTION.CATEGORY.TITLE',
        categorySectionDropdown: 'SCENARIO.SELECTION.CATEGORY.SECTION.DROPDOWN',
        categorySectionDropdownConsumer:
            'SCENARIO.SELECTION.CATEGORY.SECTION.DROPDOWN.CONSUMERELECTRONICS',
        categorySectionDropdownGrocery: 'SCENARIO.SELECTION.CATEGORY.SECTION.DROPDOWN.GROCERY',
        categorySectionDropdownNonAlcoholic:
            'SCENARIO.SELECTION.CATEGORY.SECTION.DROPDOWN.NONALCOHOLICBEVERAGES',
        categorySectionDropdownInsurance: 'SCENARIO.SELECTION.CATEGORY.SECTION.DROPDOWN.INSURANCE',
        categorySectionDropdownAlcoholic:
            'SCENARIO.SELECTION.CATEGORY.SECTION.DROPDOWN.ALCOHOLICBEVERAGES',
        mapSection: 'SCENARIO.SELECTION.MAP',
        mapSectionTitle: 'SCENARIO.SELECTION.MAP.TITLE',
        mapSectionPopup: 'SCENARIO.SELECTION.MAP.SECTION.POPUP.CONTAINER',
        mapSectionPopupTitle: 'SCENARIO.SELECTION.MAP.SECTION.POPUP.TITLE',
        mapSectionPopupClose: 'SCENARIO.SELECTION.MAP.SECTION.POPUP.CLOSE',
        mapSectionPopupSegment: 'SCENARIO.SELECTION.MAP.SECTION.POPUP.SEGMENT',
        mapSectionPopupSegmentRegion: 'SCENARIO.SELECTION.MAP.SECTION.POPUP.SEGMENT.REGION',
        mapSectionPopupSegmentDMA: 'SCENARIO.SELECTION.MAP.SECTION.POPUP.SEGMENT.DMA',
        mapSectionPopupSubDropdown: 'SCENARIO.SELECTION.MAP.SECTION.SUBDROPDOWN',
        mapSectionPopupSubDropdownWest: 'SCENARIO.SELECTION.MAP.SECTION.SUBDROPDOWN.WEST',
        mapSectionPopupSubDropdownMidWest: 'SCENARIO.SELECTION.MAP.SECTION.SUBDROPDOWN.MIDWEST',
        mapSectionPopupSubDropdownSouth: 'SCENARIO.SELECTION.MAP.SECTION.SUBDROPDOWN.SOUTH',
        mapSectionPopupSubDropdownNorthEast: 'SCENARIO.SELECTION.MAP.SECTION.SUBDROPDOWN.NORTHEAST',
        mapSectionPopupRegionGraph: 'SCENARIO.SELECTION.MAP.SECTION.REGION.GRAPH',
        mapSectionPopupRegionDMA: 'SCENARIO.SELECTION.MAP.SECTION.DMA.GRAPH',
        engagementSection: 'SCENARIO.SELECTION.ENGAGEMENT',
        engagementSectionTitle: 'SCENARIO.SELECTION.ENGAGEMENT.TITLE',
        engagementSectionInput: 'SCENARIO.SELECTION.ENGAGEMENT.SECTION.INPUT',

        generatedText: 'SCENARIO.PLOT.GENERATED.TEXT',

        plotPills: 'SCENARIO.PLOT.PILLS',
        plotPillTotalDefined: 'SCENARIO.PLOT.PILLS.TOTALDEFINEDSEGMENT',
        plotPillSex: 'SCENARIO.PLOT.PILLS.SEX',
        plotPillAgeGroup: 'SCENARIO.PLOT.PILLS.AGEGROUP',
        plotPillEthnicGroup: 'SCENARIO.PLOT.PILLS.ETHNICGROUP',
        plotPillCategory: 'SCENARIO.PLOT.PILLS.CATEGORY',
    },
};
